<template>
  <div class="pie-chart-main">
    <div class="title">{{ pieTitle }}</div>
    <div class="chart-container" v-if="items.length > 0">
      <div class="pie-container" :id="`pieContainer${pieID}`">
        <svg :id="`pieChart${pieID}`" height="90%" width="90%" style="overflow: visible">
        </svg>
        <div class="tooltip tooltip-hidden" :id="`tooltip${pieID}`" :style="{ width: `${tooltipWidth}px`, top: 0 }"></div>
      </div>
      <div class="legend-container" :id="`legend${pieID}`"></div>
    </div>
    <div class="empty-message" v-else>
      {{ emptyMessage }}
    </div>
    <div :id="`pieCMenu${pieID}`" class="context-menu context-menu-hide" :style="{ width: `${contextMenuWidth}px` }">
      <div class="context-menu-items" v-for="c in contextMenu" :key="c" @click="contextMenuClicked(c)">{{ c }} for {{ contextDetails ? contextDetails.item : '' }}</div>
      <div class="context-menu-divider"></div>
      <div class="context-menu-items" @click="contextMenuClicked('')">Close</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
var totalValue;
export default {
  components: {
  },
  props: {
    hiddenPie: { type: Array, default: function() { return [] } },
    contextDetails: { type: Object, default: function() { return null } },

    // Public properties
    items: { type: Array, default: function() { return [] } }, // The array of items
    itemName: { type: String, default: '' }, // The key of the name from the items
    itemValue: { type: String, default: '' }, // The key of the value from the items
    colors: { type: Array, default: function() { return [] } }, // The set of colors, if not specified, will use the default colors from chartColors.js
    pieTitle: { type: String, default: 'Pie Title' }, // The title of the pie chart
    pieID: { type: String, default: '' }, // Compulsory if you have multiple pie charts in one page
    emptyMessage: { type: String, default: 'No items to show' }, // Customize the message to show when the chart is empty
    tooltipFormat: { type: String, default: '' }, // Eg: The item [key] has [value] ([perc]) value for [anyKey], where key = legend, value = value of the hovered chart, perc = percentage of the pie, anyKey = any key from the object to show when hover
    tooltipWidth: { type: String, default: '100' }, // The width of the tooltip
    contextMenu: { type: Array, default: function() { return [] } }, // Add your context menu in an array of strings to show the context menu when the chart is clicked
    contextMenuWidth: { type: String, default: '100' }, // The width of the context menu

    // Public events
    // @contextMenuClicked - return 3 items, context menu name, legend name and the object of the chart that is clicked
  },
  methods: {
    // Pie Handler
    pieMouseOver: function(e) {
      var target = e.target;
      var details = JSON.parse(target.getAttribute('hoverDetails'));
      target.setAttribute('transform', `${e.target.getAttribute('transform')} scale(1.05)`);

      var color = target.getAttribute('stroke');
      var index = this.colors.indexOf(color);

      var legendContainer = document.getElementById(`legend${this.pieID}`);
      legendContainer.children[index].children[1].style.fontWeight = 'bold';
      legendContainer.children[index].children[1].style.opacity = '1';

      var tooltip = document.getElementById(`tooltip${this.pieID}`);

      tooltip.style.position = 'fixed';
      tooltip.classList.remove('tooltip-hidden');

      var percentage = `${Math.round(details[this.itemValue] / totalValue * 100)}%`;
      var key = details[this.itemName];
      var value = details[this.itemValue];

      if (!this.tooltipFormat) {
        tooltip.innerHTML = `${key}<br />${value} (${percentage})`;
      } else {
        var startIndices = [];
        var endIndices = [];
        for (var i = 0; i < this.tooltipFormat.length; i++) {
          if (this.tooltipFormat[i] == '[') {
            startIndices.push(i + 1);
          } else if (this.tooltipFormat[i] == ']') {
            endIndices.push(i);
          }
        }

        var itemKey = [];
        for (var i = 0; i < startIndices.length; i++) {
          itemKey.push(this.tooltipFormat.substring(startIndices[i], endIndices[i]));
        }

        var format = this.tooltipFormat;

        var format = format.split('[').join('');
        format = format.split(']').join('');
        itemKey.forEach((i) => { 
          format = format.replace(i, '|');
        });

        var item = format.split('|');

        var tooltipText = '';
        var hoverItemIndex = 0;
        item.forEach((i) => {
          tooltipText += i;
          if (itemKey[hoverItemIndex] == 'value') {
            tooltipText += value;
          } else if (itemKey[hoverItemIndex] == 'key') {
            tooltipText += key;
          } else if (itemKey[hoverItemIndex] == 'perc') {
            tooltipText += percentage;
          } else {
            var showItem = details[itemKey[hoverItemIndex]];
            tooltipText += `${showItem ? showItem : ''}`;
          }
          hoverItemIndex++;
        });

        tooltip.innerHTML = tooltipText;
      }
    },
    pieMouseOut: function(e) {
      e.target.setAttribute('transform', e.target.getAttribute('transform').replace(' scale(1.05)', ''));
      var allLegends = document.getElementById(`legend${this.pieID}`).children;
      for (var i = 0; i < allLegends.length; i++) {
        allLegends[i].children[1].style.fontWeight = 'unset';
        allLegends[i].children[1].style.opacity = '0.75';
      }
      document.getElementById(`tooltip${this.pieID}`).classList.add('tooltip-hidden');
    },
    pieMouseMove: function(e) {
      var tooltip = document.getElementById(`tooltip${this.pieID}`);
      var height = tooltip.getBoundingClientRect().height;
      var width = tooltip.getBoundingClientRect().width;

      tooltip.style.top = `${e.pageY - height}px`;
      tooltip.style.left = `${e.pageX - width}px`;
    },
    pieClicked: function(e) {
      var contextMenu = document.getElementById(`pieCMenu${this.pieID}`);
      var legendContainer = document.getElementById(`legend${this.pieID}`);
      var target = e.target;
      var x = e.pageX;
      var y = e.pageY;
      
      var color = target.getAttribute('stroke');
      var legendIndex = this.colors.indexOf(color);
      var legend = legendContainer.children[legendIndex].children[1].innerHTML;

      this.contextDetails = { data: JSON.parse(target.getAttribute('hoverDetails')), item: legend };

      contextMenu.classList.remove('context-menu-hide');
      contextMenu.style.top = `${e.pageY}px`;
      contextMenu.style.left = `${e.pageX - this.contextMenuWidth}px`;
    },
    contextMenuClicked: function(item) {
      var contextMenu = document.getElementById(`pieCMenu${this.pieID}`);
      contextMenu.classList.add('context-menu-hide');

      if (item) {
        this.$emit('contextMenuClicked', item, this.contextDetails.item, this.contextDetails.data);
      }

      this.contextDetails = null;
    },
    // Pie Handler
    // Legend Handler
    legendClicked: function(e) {
      var background = e.target.style.backgroundColor;
      var parent = e.target.parentElement;
      var legendItem = parent.children[1].innerHTML;

      if (background.includes('rgb')) {
        background = this.rgbToHex(background);
      }

      if (background == 'transparent') {
        e.target.style.backgroundColor = e.target.style.borderColor;
        var index = this.hiddenPie.indexOf(legendItem);
        this.hiddenPie.splice(index, 1);
      } else {
        e.target.style.backgroundColor = 'transparent';
        this.hiddenPie.push(legendItem);
      }

      this.resize();
    },
    // Legend Handler
    createCircle: function(chart, color, percentage, rotation, details) {
      var width = chart.getBoundingClientRect().width;
      var height = chart.getBoundingClientRect().height;
      var size = width < height ? width : height;

      var circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      circle.setAttribute('r', size / 4);
      circle.setAttribute('cx', '50%');
      circle.setAttribute('cy', '50%');
      circle.setAttribute('fill', 'none');
      circle.setAttribute('stroke', color);
      circle.setAttribute('stroke-width', size / 2);
      circle.setAttribute('stroke-dasharray', `calc(${percentage} * ${1.571 * size} / 100) ${1.571 * size}`);
      circle.setAttribute('transform-origin', '50% 50%');
      circle.setAttribute('transform', `rotate(${rotation})`);
      circle.setAttribute('transition', '1s');
      circle.setAttribute('hoverDetails', JSON.stringify(details));

      circle.addEventListener('mouseover', this.pieMouseOver);
      circle.addEventListener('mouseout', this.pieMouseOut);
      circle.addEventListener('mousemove', this.pieMouseMove);
      if (this.contextMenu.length > 0) {
        circle.setAttribute('cursor', 'pointer');
        circle.addEventListener('click', this.pieClicked);
      }

      return circle;
    },
    createLegendItem: function(color, text) {
      var legendItem = document.createElement('div');
      legendItem.className = 'legend-item';

      var legendColor = document.createElement('div');
      legendColor.className = 'legend-color';

      legendColor.style.backgroundColor = `${color}`;
      legendColor.style.borderColor = `${color}`;
      legendColor.addEventListener('click', this.legendClicked);

      var legendText = document.createElement('div');
      legendText.innerHTML = text;
      legendText.style.opacity = 0.75;

      legendItem.appendChild(legendColor);
      legendItem.appendChild(legendText);

      return legendItem;
    },
    rgbToHex: function(rgb) {
      rgb = rgb.replace('rgb', '');
      rgb = rgb.replace('(', '');
      rgb = rgb.replace(')', '');
      var rgbValues = rgb.split(',');

      var hexValue = '';
      rgbValues.forEach((v) => {
        var hex = Number(v.trim()).toString(16);
        if (hex.length < 2) {
            hex = "0" + hex;
        }
        hexValue += `${hex}`;
      });

      return `#${hexValue}`.toUpperCase();
    },
    resize: function() {
      var allValue = this.items.map((i) => {
        if (!this.hiddenPie.includes(i[this.itemName])) {
          return Number(i[this.itemValue].toString().replace(/[^0-9.-]+/g,""));
        } else {
          return 0;
        }
      });
      totalValue = allValue.reduce((a, b) => { return a + b });

      var rotation = -90;
      var container = document.getElementById(`pieContainer${this.pieID}`);
      var chart = document.getElementById(`pieChart${this.pieID}`);
      var legend = document.getElementById(`legend${this.pieID}`);
      chart.innerHTML = '';

      // Creating the legend
      if (legend.innerHTML == '') {
        this.items.forEach((t, i) => {
          legend.appendChild(this.createLegendItem(this.colors[i], t[this.itemName]));
        });
      }
      // Creating the legend

      // Creating the pie chart
      var allRotationPoint = [];
      this.items.forEach((t, i) => {
        if (!this.hiddenPie.includes(t[this.itemName])) {
          var percentage = t[this.itemValue] / totalValue * 100;
          chart.appendChild(this.createCircle(chart, this.colors[i], percentage, rotation, t));
          
          var startRotation = rotation + 90;
          rotation += percentage / 100 * 360;
          var endRotation = rotation + 90;

          allRotationPoint.push([ startRotation, endRotation ]);
        }
      });
      // Creating the pie chart

      var chartSize = chart.getBoundingClientRect();

      var chartXCenter = chartSize.width / 2;
      var chartYCenter = chartSize.height / 2;
      var size = chartSize.width < chartSize.height ? chartSize.width : chartSize.height;

      // Creating the percentage label
      allRotationPoint.forEach((r) => {
        var fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
        fObject.setAttribute('width', 40);
        fObject.setAttribute('height', 10);
        fObject.setAttribute('x', chartXCenter - 20);
        fObject.setAttribute('y', chartYCenter - 8);

        var midPoint = (r[0] + r[1]) / 2;
        var percentageRadius = (size / 2) * 2 / 3;
        var rad = (midPoint - 90) * Math.PI / 180;
        var x = percentageRadius * Math.cos(rad);
        var y = percentageRadius * Math.sin(rad);
        fObject.style = `overflow: visible; transform: translate(${x}px, ${y}px)`;
  
        var span = document.createElement('span');
        span.className = 'pie-percentage';
        span.innerHTML = `${Math.round((r[1] - r[0]) / 360 * 100)}%`;
  
        fObject.appendChild(span);
        chart.appendChild(fObject);
      });
      // Creating the percentage label
    },
    loadPie: function() {
      setTimeout(() => {
        document.getElementById(`legend${this.pieID}`).innerHTML = '';

        this.resize();
      }, 100);
    }
  },
  mounted() {
    if (this.colors.length == 0) {
      this.colors = this.$chartColors.getColors();
    }

    window.addEventListener('resize', this.resize);
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.pie-chart-main {
  width: 100%;
  height: 100%;
  font-size: 12px;

  > .title {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    text-align: center;
  }

  > .chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 20px);

    > .legend-container {
      max-width: 150px;
      min-width: 100px;
      height: 100%;
      font-size: 10px;
      padding: 5px;
      overflow-y: auto;
    }

    > .pie-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
    }
  }

  > .empty-message {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
</style>

<style>
.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  position: relative;
}

.legend-color {
  min-height: 15px;
  min-width: 15px;
  margin-right: 5px;
  cursor: pointer;
  border-width: 3px;
  border-style: solid;
  border-radius: 5px;
}

.pie-percentage {
  opacity: 0.75;
  font-size: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>